import {
  computed,
  Directive,
  InjectionToken,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
export const PREFIX_DIRECTIVE: InjectionToken<PrefixDirective> =
  new InjectionToken<PrefixDirective>('PrefixDirective');

@Directive({
  selector: '[lyceoIconPrefix], [lyceoTextPrefix]',
  providers: [{ provide: PREFIX_DIRECTIVE, useExisting: PrefixDirective }],
})
export class PrefixDirective {
  public readonly lyceoTextPrefix: InputSignal<'' | undefined> = input<''>();

  public readonly isText: Signal<boolean> = computed<boolean>(
    () => this.lyceoTextPrefix() !== undefined,
  );
}
